import styles from "./styles.module.scss";

interface Props {
  children: any;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}

export function TooltipAtom(props: Readonly<Props>) {
  return (
    <button
      type="button"
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
      onFocus={props.onMouseEnter}
      onBlur={props.onMouseLeave}
      className={styles.tooltip}
    >
      {props.children}
    </button>
  );
}
